import Listening from "../components/listening";
import Introduction from "../components/introduction";
import Projects from "../components/projects";
import HomeAMA from "../components/homeama";
import RecentPosts from "../components/recentposts";
import Layout from "../components/layout";

function Home() {
  return (
    <div className="flex-grow bg-slate-900 text-slate-200">

      <Listening />

      {/* Introduction - block centered, text left-aligned */}
      <Layout className="py-12">
        <div className="flex flex-col items-center">
          <div className="w-full md:w-3/4">
            <Introduction />
          </div>
        </div>
      </Layout>

      <Layout className="py-4">
        <HomeAMA />
      </Layout>

      <Layout className="py-10">
        <Projects />
      </Layout>

      <Layout className="py-10">
        <RecentPosts />
      </Layout>

    </div>
  );
}

export default Home;